// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ia-z","fullWidth":"Ja-z","heading":"Ka-z","fullBleed":"La-z","hidden":"Ma-z"};